import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface IPagoWeb {
  oidLiquidacion: number;
  oidBanco: number | undefined;
  tipoDocumento: string | null;
  documento: string | null;
}

interface IPagoWebResponse {
  ok: boolean;
  mensaje: string;
  guidMensaje: string;
}

export const pagoWeb = async (query: IPagoWeb): Promise<IPagoWebResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<IPagoWebResponse>>(
      Endpoints.PagoWeb,
      {
        oidLiquidacion: query.oidLiquidacion,
        oidBanco: query.oidBanco,
        tipoDocumento: query.tipoDocumento,
        documento: query.documento,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
